import React, { useState, useEffect, useRef } from 'react';
import { getApiBaseUrl } from "../utils/apiAssetUrl";
import '../CSS/Global.css';
import vendorFormImage from '../Images/vendor-form-image.webp';
import ImageUpload from './ImageUpload';
import { Badge, Box, Button, Flex, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Select, Spinner, Switch, Text, useDisclosure, useToast } from '@chakra-ui/react';
import Header from './Header';
import { Autocomplete, useLoadScript } from '@react-google-maps/api';
import { CheckCircleIcon, CloseIcon, WarningTwoIcon } from '@chakra-ui/icons';
import {
    Heading,
    VStack,
    HStack,
    Divider,
    useColorModeValue,
} from "@chakra-ui/react";
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { format } from "date-fns";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.css";
import { INDIA_DATA } from "./indiaStatesCities"
import { validateAadharOptional, validatePanOptional } from "../utils/indiaIdValidation";
import { emptySocialMediaLinks } from "../utils/socialMediaLinks";
import { resolveListingSubmitErrorMessage } from "../utils/listingSubmitErrors";

const ListingForm = () => {
    const API_BASE = getApiBaseUrl();
    const [step, setStep] = useState(0);
    const [store, setStore] = useState(false);
    const [businessDetails, setBusinessDetails] = useState({});
    const [contactDetails, setContactDetails] = useState({});
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [locationDetectLoading, setLocationDetectLoading] = useState(false);
    const [google_address, setGoogleAddress] = useState()
    const [businessDate, setBusinessdate] = useState();
    const [focusedField, setFocusedField] = useState('');
    const [filteredStates, setFilteredStates] = useState([]);
    const [filteredCities, setFilteredCities] = useState([]);
    // const [cities, setCities] = useState([]);
    const [showStateDropdown, setShowStateDropdown] = useState(false);
    const [showCityDropdown, setShowCityDropdown] = useState(false);


    // const [businessTiming, setBusinessTiming] = useState({
    //     timeSlots: [{ openTime: '', closeTime: '' }], // Default time slot
    //     selectedDays: {},
    // });
    const [businessTiming, setBusinessTiming] = useState({
        timeSlots: [{ day: '', openTime: '', closeTime: '' }], // Each time slot has a single day
    });
    const [formImages, setFormImages] = useState([]);
    const { isOpen: isModal1Open, onOpen: openModal1, onClose: closeModal1 } = useDisclosure();
    const { isOpen: isModal2Open, onOpen: openModal2, onClose: closeModal2 } = useDisclosure();
    const login = JSON.parse(localStorage.getItem("login")) || "";
    const autocompleteRef = useRef(null);
    const autocompleteRef1 = useRef(null);
    const [vendor_location, setVendorLocation] = useState()
    const [selectedLocation, setSelectedLocation] = useState({
        lat: "",
        lng: '',
    });
    const [cities, setCities] = useState([]);
    const [plan, setPlan] = useState([])
    const [scrollBehavior, setScrollBehavior] = React.useState('inside')
    const libraries = ['places'];

    const handleChange = (date) => {
        // Convert date to string in the required format
        const formattedDate = date ? date.toLocaleDateString('en-GB') : '';

        if (validateDateFormat(formattedDate)) {
            setBusinessdate(date); // Update the state with the valid date
        } else {
            alert("Invalid date format. Please enter the date in dd/MM/yyyy format.");
        }
    };


    const toast = useToast();
    const { isLoaded } = useLoadScript({
        googleMapsApiKey: 'AIzaSyD0AcxoBWhqkMIAfK-F-X6ya3Es-52o1YU', // Replace with your API key
        libraries,
    });


    const [paymentDetails, setPaymentDetails] = useState({});
    const [servicesDetails, setServicesDetails] = useState({});
    //const [images, setImages] = useState([]);

    // Track additional input fields for mobile, WhatsApp, landline, email
    const [additionalMobiles, setAdditionalMobiles] = useState([]);
    const [additionalWhatsapps, setAdditionalWhatsapps] = useState([]);
    const [additionalLandlines, setAdditionalLandlines] = useState([]);
    const [additionalEmails, setAdditionalEmails] = useState([]);
    const [additionalServices, setAdditionalServices] = useState([]);
    const [planobject, setPlanObject] = useState({})
    const [gst, setGst] = useState({});
    const [aadharNumber, setAadharNumber] = useState("");
    const [panNumber, setPanNumber] = useState("");
    const [socialMediaLinks, setSocialMediaLinks] = useState(emptySocialMediaLinks());
    const [load, setLoad] = useState(true);
    const [alltime, setAllTime] = useState(false);
    const [catgeoryArray, setCategoryArray] = useState({})
    const [subcatgeoryArray, setSubCategoryArray] = useState({})
    const [errors, setErrors] = useState({});
    const [aadharFieldError, setAadharFieldError] = useState("");
    const [panFieldError, setPanFieldError] = useState("");

    const handleAdditionalMobileChange = (index, e) => {
        const updatedMobiles = [...additionalMobiles];
        updatedMobiles[index] = e.target.value;
        setAdditionalMobiles(updatedMobiles);
    };

    const handleAdditionalWhatsappChange = (index, e) => {
        const updatedWhatsapps = [...additionalWhatsapps];
        updatedWhatsapps[index] = e.target.value;
        setAdditionalWhatsapps(updatedWhatsapps);
    };

    const handleAdditionalEmailChange = (index, e) => {
        const updatedEmails = [...additionalEmails];
        updatedEmails[index] = e.target.value;
        setAdditionalEmails(updatedEmails);
    };

    const handleAdditionalLandlineChange = (index, e) => {
        const updatedLandlines = [...additionalLandlines];
        updatedLandlines[index] = e.target.value;
        setAdditionalLandlines(updatedLandlines);
    };

    const handleAdditionalServicesChange = (index, e) => {
        const updatedServices = [...additionalServices];
        updatedServices[index] = e.target.value;
        setAdditionalServices(updatedServices);
    };


    const handleBusinessDetailsChange = (e) => {
        setBusinessDetails({ ...businessDetails, [e.target.name]: e.target.value });
    };

    const handleContactDetailsChange = (e) => {
        setContactDetails({ ...contactDetails, [e.target.name]: e.target.value });
    };

    const handlePaymentDetailsChange = (e) => {
        setPaymentDetails({ ...paymentDetails, [e.target.name]: e.target.value });
    };

    const handleServicesDetailsChange = (e) => {
        setServicesDetails({ ...servicesDetails, [e.target.name]: e.target.value });
    };

    const handleSocialLinkChange = (key, value) => {
        setSocialMediaLinks((prev) => ({ ...prev, [key]: value }));
    };

    const validateDateFormat = (dateString) => {
        const regex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
        return regex.test(dateString);
    };

    const handleNextStep = () => {
        if (!validateStep(step)) {
            // toast({
            //     // title: "Validation Error",
            //     description: "Please fill all the required fields.",
            //     status: "error",
            //     duration: 5000,
            //     isClosable: true,
            //     position: "top",
            // });
            return;
        }
        setStep(step + 1);
    };

    const validateStep = (currentStep) => {
        let missing = [];

        switch (currentStep) {

            case 0: {
                const { businessName, buildingName, street, city, state, pincode, description } = businessDetails;

                if (!businessName) missing.push("Business Name");
                if (!buildingName) missing.push("Building Name");
                if (!street) missing.push("Street");
                if (!city) missing.push("City");
                if (!state) missing.push("State");
                if (!pincode) missing.push("Pincode");
                if (!description) missing.push("Description");
                break;
            }

            case 1: {
                const { title, personName, mobile, email } = contactDetails;

                if (!title) missing.push("Title");
                if (!personName) missing.push("Person Name");
                if (!mobile) missing.push("Mobile Number");
                if (!email) missing.push("Email");

                if (missing.length === 0) {
                    const aad = validateAadharOptional(aadharNumber);
                    const pan = validatePanOptional(panNumber);
                    setAadharFieldError(aad.ok ? "" : aad.message);
                    setPanFieldError(pan.ok ? "" : pan.message);
                    if (!aad.ok || !pan.ok) {
                        const parts = [aad.ok ? "" : aad.message, pan.ok ? "" : pan.message].filter(Boolean);
                        toast({
                            description: parts.join(" "),
                            status: "error",
                            duration: 6000,
                            isClosable: true,
                            position: "top",
                        });
                        return false;
                    }
                }
                break;
            }

            case 2: {
                if (!Array.isArray(businessTiming.timeSlots) || businessTiming.timeSlots.length === 0) {
                    missing.push("Time Slots");
                } else {
                    businessTiming.timeSlots.forEach((slot, i) => {
                        const day = (slot?.day || "").trim();
                        const openTime = (slot?.openTime || "").trim();
                        const closeTime = (slot?.closeTime || "").trim();
                        if (!day) missing.push(`Time Slot #${i + 1}: Day`);
                        if (!openTime) missing.push(`Time Slot #${i + 1}: Open Time`);
                        if (!closeTime) missing.push(`Time Slot #${i + 1}: Close Time`);
                    });
                }
                break;
            }

            case 3: {
                if (!servicesDetails.service) missing.push("Service/Skills");
                if (!selectedCategory) missing.push("Category");
                if (!gst.gstAvailable) missing.push("GST Available");
                if (gst.gstAvailable === "Yes" && !gst.gstNumber) missing.push("GST Number");
                // If subcategories are available, user must select one
                if (subCategories.length > 0 && !selectedSubCategory) missing.push("Subcategory");
                break;
            }

            case 4:
                if (formImages.length === 0) missing.push("Images");
                break;

            case 5: {
                // Payment / bank fields are all optional
                const acc = (paymentDetails.accountNumber || "").trim();
                const conf = (paymentDetails.confirmaccountNumber || "").trim();
                if (acc && conf && acc !== conf) {
                    toast({
                        description:
                            "Bank Account Number and Confirm Bank Account Number do not match.",
                        status: "error",
                        duration: 6000,
                        isClosable: true,
                        position: "top",
                    });
                    return false;
                }
                break;
            }
        }

        if (missing.length > 0) {
            toast({
                description: `Please fill: ${missing.join(", ")}`,
                status: "error",
                duration: 6000,
                isClosable: true,
                position: "top",
            });
            return false;
        }

        return true;
    };



    const handlePrevStep = () => {
        setStep(step - 1);
    };

    // Handlers to add new input fields
    const addNewMobileField = () => {
        setAdditionalMobiles([...additionalMobiles, '']);
    };

    const addNewWhatsAppField = () => {
        setAdditionalWhatsapps([...additionalWhatsapps, '']);
    };

    const addNewLandlineField = () => {
        setAdditionalLandlines([...additionalLandlines, '']);
    };

    const addNewEmailField = () => {
        setAdditionalEmails([...additionalEmails, '']);
    };

    const addNewServicesField = () => {
        setAdditionalServices([...additionalServices, '']);
    };

    const handleTimeSlotChange = (index, field, value) => {
        const updatedTimeSlots = [...businessTiming.timeSlots];

        // Handle "Always Open"
        if (value === "Always Open") {
            updatedTimeSlots[index] = {
                day: "Always Open",
                openTime: "00:00",
                closeTime: "23:59",
            };
        } else {
            updatedTimeSlots[index][field] = value;
        }

        setBusinessTiming({ ...businessTiming, timeSlots: updatedTimeSlots });
    };

    const handleAddTimeSlot = () => {
        setBusinessTiming((prev) => ({
            ...prev,
            timeSlots: [...prev.timeSlots, { day: '', openTime: '', closeTime: '' }],
        }));
    };


    const handleRemoveTimeSlot = (index) => {
        const updatedTimeSlots = businessTiming.timeSlots.filter((_, i) => i !== index);
        setBusinessTiming({ ...businessTiming, timeSlots: updatedTimeSlots });
    };

    // const handleTimeSlotChange = (index, e) => {
    //     const updatedTimeSlots = [...businessTiming.timeSlots];
    //     updatedTimeSlots[index][e.target.name] = e.target.value;
    //     setBusinessTiming({ ...businessTiming, timeSlots: updatedTimeSlots });
    // };

    // const handleTimeSlotChange = (index, field, value) => {
    //     const updatedTimeSlots = [...businessTiming.timeSlots];
    //     updatedTimeSlots[index][field] = value;
    //     setBusinessTiming({ ...businessTiming, timeSlots: updatedTimeSlots });
    // };


    const handleCheckboxChange = (day) => {
        setBusinessTiming(prev => ({
            ...prev,
            selectedDays: {
                ...prev.selectedDays,
                [day]: !prev.selectedDays[day],
            },
        }));
    };

    const [categories, setCategories] = useState([]); // All categories
    const [selectedCategory, setSelectedCategory] = useState(null); // Selected category ID
    const [subCategories, setSubCategories] = useState([]); // Subcategories of selected category
    const [selectedSubCategory, setSelectedSubCategory] = useState("");
    const [googleAddress, setGoogleAddresss] = useState("");


    const renderTimeSlots = () => (
        <div>
            {businessTiming.timeSlots.map((slot, index) => (
                <div key={index} className="time-slot">
                    <div className="time-slot-list">
                        {/* Day Selection */}
                        <select
                            name="day"
                            value={slot.day}
                            onChange={(e) => handleTimeSlotChange(index, 'day', e.target.value)}
                            disabled={alltime}
                        >
                            <option value="">Select Day</option>
                            {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Mon-Fri', 'Mon-Sat', 'All-Days', "Always Open"].map((day) => (
                                <option key={day} value={day}>
                                    {day}
                                </option>
                            ))}
                        </select>

                        {/* Open Time Selection */}
                        <select
                            name="openTime"
                            value={slot.openTime}
                            onChange={(e) => handleTimeSlotChange(index, 'openTime', e.target.value)}
                            disabled={slot.day === "Always Open"}
                        >
                            <option value="">Select Open Time</option>
                            {Array.from({ length: 24 }, (_, i) => (
                                <option key={i} value={`${i < 10 ? '0' : ''}${i}:00`}>
                                    {`${i < 10 ? '0' : ''}${i}:00`}
                                </option>
                            ))}
                        </select>

                        {/* Close Time Selection */}
                        <select
                            name="closeTime"
                            value={slot.closeTime}
                            onChange={(e) => handleTimeSlotChange(index, 'closeTime', e.target.value)}
                            disabled={slot.day === "Always Open"}
                        >
                            <option value="">Select Close Time</option>
                            {Array.from({ length: 24 }, (_, i) => (
                                <option key={i} value={`${i < 10 ? '0' : ''}${i}:00`}>
                                    {`${i < 10 ? '0' : ''}${i}:00`}
                                </option>

                            ))}
                            <option value="23:59">23:59</option>
                        </select>
                    </div>

                    <button disabled={slot.day === "Always Open"} className="listing-add-button" onClick={() => handleRemoveTimeSlot(index)}>
                        Remove
                    </button>
                </div>
            ))}
        </div>
    );

    const getPlan = async () => {
        try {
            const response = await fetch(`${API_BASE}/vendor-storepricing/all/pricingall`);
            if (!response.ok) {
                console.warn("getPlan: HTTP", response.status);
                setPlan([]);
                return;
            }
            const res = await response.json();
            const list = Array.isArray(res) ? res : Array.isArray(res?.data) ? res.data : [];
            setPlan(list);
        } catch (error) {
            console.warn("getPlan:", error);
            setPlan([]);
        }
    };

    const plans = [
        {
            name: "BASIC",
            price: "$4.99",
            period: "/mon",
            features: "Best Plan for 1 year",
            highlight: false,
        },
        {
            name: "STANDARD",
            price: "$9.99",
            period: "/mon",
            features: "Best Plan for 1 year",
            highlight: true,
        },
        {
            name: "PREMIUM",
            price: "$14.99",
            period: "/mon",
            features: "Best Plan for 1 year",
            highlight: true,
        },

    ];

    const navigate = useNavigate();

    const listingSuccessCopy =
        "Your listing has been created successfully and submitted for approval. Once it is approved, it will be visible on the app.";

    const [listingResultModal, setListingResultModal] = useState({
        isOpen: false,
        variant: "success",
        message: "",
    });

    const closeListingResultModal = () =>
        setListingResultModal((s) => ({ ...s, isOpen: false }));

    const openListingResultModal = (variant, message) =>
        setListingResultModal({ isOpen: true, variant, message });

    const confirmListingSuccess = () => {
        setListingResultModal((s) => ({ ...s, isOpen: false }));
        navigate("/user-profile");
    };

    /** Public list endpoint (no FAKENAME gate — unlike /getcategory/:id on some deployments). */
    const fetchDataCategory = async () => {
        try {
            const response = await fetch(`${API_BASE}/category/getcategory`);
            if (!response.ok) {
                console.warn("fetchDataCategory: HTTP", response.status);
                return;
            }
            const res = await response.json();
            const list = Array.isArray(res)
                ? res
                : Array.isArray(res?.data)
                  ? res.data
                  : [];
            setCategories(list);
        } catch (error) {
            console.warn("fetchDataCategory:", error?.message || error);
        }
    };

    // const handleCategoryChange = (e) => {
    //     const categoryId = e.target.value;
    //     setSelectedCategory(categoryId);

    //     // Find the selected category's associated subcategories
    //     const selectedCat = categories.find(cat => cat.category_name === (categoryId));
    //     console.log(selectedCat)
    //     setSubCategories(selectedCat?.associatedsubcategory || []);
    //     setSelectedSubCategory(null); // Reset subcategory on category change
    // };

    const handleCategoryChange = (e) => {
        const categoryName = e.target.value;

        // Find full category object
        const selectedCat = categories.find(
            (cat) => cat.category_name === categoryName
        );

        setSelectedCategory(categoryName);

        // Store full category object
        setCategoryArray(selectedCat);

        // Set subcategories
        setSubCategories(selectedCat?.associatedsubcategory || []);

        // Reset subcategory
        setSelectedSubCategory(null);
        setSubCategoryArray({});
    };

    console.log(catgeoryArray, subcatgeoryArray)

    const handleSubCategoryChange = (e) => {
        const subCatName = e.target.value;

        setSelectedSubCategory(subCatName);

        // Find full subcategory object
        const selectedSubCat = subCategories.find(
            (sub) => sub.subcategory_name === subCatName
        );

        // Store full obj
        setSubCategoryArray(selectedSubCat);
    };


    // Handle subcategory selection
    // const handleSubCategoryChange = (e) => {
    //     setSelectedSubCategory(e.target.value);
    // };

    const loadScript = (src) => {
        return new Promise((resolve) => {
            const script = document.createElement("script");
            script.src = src;
            script.onload = () => {
                resolve(true);
            };
            script.onerror = () => {
                resolve(false)
            }
            document.body.appendChild(script);
        })
    };

    const handlePayment = async (planmain) => {

        setLoad(false);
        let orderIdMain = "11" + Math.floor(Math.random() * Math.floor(Math.random() * Date.now()));

        const acc = (paymentDetails.accountNumber || "").trim();
        const conf = (paymentDetails.confirmaccountNumber || "").trim();
        if (acc && conf && acc !== conf) {
            toast({
                description:
                    "Bank Account Number and Confirm Bank Account Number do not match.",
                status: "error",
                duration: 5000,
                isClosable: true,
                position: "top",
            });
            setLoad(true);
            return;
        }

        // Bank fields come from React state (paymentDetails). We'll merge them
        // with the gateway payment details before submitting to `add-store`.
        const bankPaymentDetailsForStore = { ...paymentDetails };

        if (Number(planmain.sale_price) === 0) {
            const orderId = orderIdMain;
            const validityDays = Number(planmain.validity) || 30;
            const userPhone = login.mobile || login.name || "";
            let gatewayPaymentDetails = {
                user_id: login.permanent_ID,
                user_phone: userPhone,
                transaction_id: orderId,
                amount: 0,
                validity: validityDays,
                currency: "INR",
                payment_mode: "free",
                status: "Paid",
            };

            try {
                let result = await axios.post(
                    `${API_BASE}/pay-storefees/subscription-paid`,
                    gatewayPaymentDetails
                );

                const paymentDetailsForStore = {
                    ...gatewayPaymentDetails,
                    ...bankPaymentDetailsForStore,
                };

                await handleSubmit(result.data.payments, paymentDetailsForStore);
            } catch (error) {
                console.error("Free plan submission:", error.response?.data || error.message);
                openListingResultModal(
                    "error",
                    error.response?.data?.message ||
                        "We couldn't complete registration. Check your connection and try again."
                );
            }

            setLoad(true);
            return; // ❌ STOP here — do NOT continue to Razorpay
        } else {
            let orderId = orderIdMain;

            try {
                let res = await loadScript("https://checkout.razorpay.com/v1/checkout.js");
                if (!res) {
                    openListingResultModal(
                        "error",
                        "The payment system failed to load. Please refresh the page and try again."
                    );
                    setLoad(true);
                    return;
                }

                let gatewayPaymentDetails = {
                    user_id: login.permanent_ID,
                    user_phone: login.name,
                    transaction_id: orderId,
                    amount: parseInt(planmain.sale_price) * 100,
                    validity: planmain.validity,
                    currency: "INR",
                    payment_capture: 1,
                    payment_mode: "online",
                };

                let options = {
                    key: "rzp_test_zEWr4dOpfx4w2F",
                    amount: gatewayPaymentDetails.amount,
                    currency: "INR",
                    name: "Film Location",
                    description: "Store Registration",
                    handler: async function (response) {
                        gatewayPaymentDetails.razorpay_payment_id = response.razorpay_payment_id;
                        gatewayPaymentDetails.status = "Paid";

                        let result = await axios.post(
                            `${API_BASE}/pay-storefees`,
                            gatewayPaymentDetails
                        );

                        const paymentDetailsForStore = {
                            ...gatewayPaymentDetails,
                            ...bankPaymentDetailsForStore,
                        };

                        await handleSubmit(result.data.payments, paymentDetailsForStore);
                        setLoad(true);
                    },
                };

                let paymentObject = new window.Razorpay(options);

                paymentObject.open();
                return;

            } catch (error) {
                console.log(error);
                setLoad(true);
            }
        }

        setLoad(true);
    }

    const [loadedDraft, setLoadedDraft] = useState(false);



    // Append business details
    const handleSubmit = async (statuspay, paymentDetailsForStore) => {
        const paymentStatus =
            typeof statuspay === "string"
                ? statuspay
                : (statuspay?.status || statuspay?.payment_status || statuspay?.paymentStatus || "");

        const normalizedStatus = (paymentStatus || "").toString().trim().toLowerCase();
        if (normalizedStatus !== "paid") {
            openListingResultModal(
                "error",
                "Payment could not be verified. Please try again or use another payment method."
            );
            return false;
        }

        const aadSubmit = validateAadharOptional(aadharNumber);
        const panSubmit = validatePanOptional(panNumber);
        setAadharFieldError(aadSubmit.ok ? "" : aadSubmit.message);
        setPanFieldError(panSubmit.ok ? "" : panSubmit.message);
        if (!aadSubmit.ok || !panSubmit.ok) {
            const parts = [
                aadSubmit.ok ? "" : aadSubmit.message,
                panSubmit.ok ? "" : panSubmit.message,
            ].filter(Boolean);
            openListingResultModal("error", parts.join(" "));
            return false;
        }

        if (!formImages || formImages.length === 0) {
            const msg =
                'No photos to upload. Go back to “Add Photos”, choose JPG/PNG/WebP (max 1 MB each), then complete payment again.';
            toast({
                title: "Photos missing",
                description: msg,
                status: "error",
                duration: 12000,
                isClosable: true,
                position: "top",
            });
            openListingResultModal("error", msg);
            setLoad(true);
            return false;
        }

        const resolvedPaymentDetailsForStore = paymentDetailsForStore || paymentDetails;

        const validityDays =
            Number(planobject?.validity) ||
            Number(resolvedPaymentDetailsForStore?.validity) ||
            30;
        const periodEnd = new Date();
        periodEnd.setDate(periodEnd.getDate() + validityDays);
        const rawId = planobject?.id ?? planobject?.vendorPricingId;
        const numId = rawId != null && rawId !== "" ? Number(rawId) : NaN;
        const catalogPlanId = Number.isFinite(numId) ? numId : null;
        const planObjectForStore = {
            id: catalogPlanId,
            vendorPricingId: catalogPlanId,
            plan_name: planobject?.plan_name || "",
            validity: Number(planobject?.validity) || validityDays,
            regular_price:
                planobject?.regular_price != null && planobject?.regular_price !== ""
                    ? Number(planobject.regular_price)
                    : undefined,
            sale_price: planobject?.sale_price != null && planobject?.sale_price !== "" ? Number(planobject.sale_price) : 0,
            description: planobject?.description || "",
            purchasedAt: new Date().toISOString(),
            validUntil: periodEnd.toISOString(),
        };

        const formData = new FormData();
        formData.append('businessDetails', JSON.stringify(businessDetails));
        formData.append('contactDetails', JSON.stringify(contactDetails));
        formData.append('google_address', google_address);
        formData.append('paymentDetails', JSON.stringify(resolvedPaymentDetailsForStore));
        formData.append('servicesDetails', JSON.stringify(servicesDetails));
        formData.append('businessTiming', JSON.stringify(businessTiming));
        formData.append('category', selectedCategory);
        formData.append('categoryArray', JSON.stringify(catgeoryArray));
        formData.append('subcategory', selectedSubCategory);
        formData.append('subcatgeoryArray', JSON.stringify(subcatgeoryArray));
        formData.append('user_id', login.permanent_ID);
        formData.append('user_name', login.name);
        formData.append('businessDate', businessDate);
        // Await admin activation in panel; VendorPlans shows "under verification"
        formData.append('status', 'Pending');
        formData.append('planObject', JSON.stringify(planObjectForStore));
        // Backend expects gst_avail "yes"|"no" (see UserProfile update-store); UI uses gstAvailable Yes|No.
        const gstAvailRaw = gst?.gstAvailable ?? gst?.gst_avail ?? "";
        const gstAvailLower = String(gstAvailRaw).trim().toLowerCase();
        const gstAvailApi = gstAvailLower === "yes" ? "yes" : gstAvailLower === "no" ? "no" : "";
        const gstNoApi =
            gstAvailApi === "yes"
                ? String(gst?.gstNumber ?? gst?.gst_no ?? "").trim()
                : "";
        formData.append("gst_no", gstNoApi);
        formData.append("gst_avail", gstAvailApi);
        formData.append("aadhar_no", aadSubmit.normalized || "");
        formData.append("pan_no", panSubmit.normalized || "");
        formData.append("socialMediaLinks", JSON.stringify(socialMediaLinks));
        formData.append('location_lat', selectedLocation.lat);
        formData.append('location_long', selectedLocation.lng);
        formData.append('additionalMobiles', JSON.stringify(additionalMobiles));
        formData.append('additionalWhatsapps', JSON.stringify(additionalWhatsapps));
        formData.append('additionalEmails', JSON.stringify(additionalEmails));
        formData.append('additionalLandlines', JSON.stringify(additionalLandlines));
        formData.append('additionalServices', JSON.stringify(additionalServices));
        formImages.forEach((image) => {
            formData.append(`formImages`, image);
        });

        for (let [key, value] of formData.entries()) {
            console.log(key, value);
        }

        try {
            const response = await fetch(`${API_BASE}/store/add-store/${login.permanent_ID}`, {
                method: 'POST',
                body: formData,
            });

            if (response.ok) {
                console.log("Form submitted successfully");
                localStorage.removeItem("listingFormDraft");
                openListingResultModal("success", listingSuccessCopy);
                return true;
            }

            const defaultErr =
                "This listing could not be submitted. If you already have a store, you may need to update it from your profile.";
            const genericServerErr =
                "The server could not create this listing. Check Tax ID (GST) fields, category, location, or whether a store already exists for your account.";

            let errMsg = defaultErr;
            try {
                const data = await response.json();
                const friendly = resolveListingSubmitErrorMessage(data);
                if (friendly) {
                    errMsg = friendly;
                } else if (data?.isError) {
                    errMsg = genericServerErr;
                }
            } catch {
                try {
                    const text = await response.text();
                    if (text) errMsg = text.slice(0, 280);
                } catch {
                    /* keep default */
                }
            }

            toast({
                title: "Could not submit listing",
                description: errMsg,
                status: "error",
                duration: 12000,
                isClosable: true,
                position: "top",
            });
            openListingResultModal("error", errMsg);
            return false;
        } catch (error) {
            console.error('Error:', error);
            const networkMsg =
                "Something went wrong while submitting your listing. Please check your connection and try again.";
            toast({
                title: "Could not submit listing",
                description: networkMsg,
                status: "error",
                duration: 12000,
                isClosable: true,
                position: "top",
            });
            openListingResultModal("error", networkMsg);
            return false;
        }
    };



    const handleSelectAllDays = () => {
        const areAllSelected = Object.keys(businessTiming.selectedDays).length === 7 && Object.values(businessTiming.selectedDays).every(Boolean);
        const updatedSelectedDays = {};

        ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].forEach(day => {
            updatedSelectedDays[day] = !areAllSelected;
        });

        setBusinessTiming(prev => ({
            ...prev,
            selectedDays: updatedSelectedDays,
        }));
    };



    const handleSkip = () => {
        // Skip the step without validating or saving the current data
        console.log('Skipped current step!');
        setStep(step + 1); // Proceed to the next step
    };

    const removeMobileField = (index) => {
        const updatedMobiles = additionalMobiles.filter((_, i) => i !== index);
        setAdditionalMobiles(updatedMobiles);
    };

    const renderProgressBar = () => {
        const steps = Array(6).fill(null); // Steps: 0..5
        return (
            <div className="tube-progress-bar">
                {steps.map((_, index) => (
                    <div key={index} className={`tube-progress-step ${index <= step ? 'active' : ''}`}></div>
                ))}
            </div>
        );
    };
    const formData = {
        businessDetails,
        contactDetails,
        businessTiming,
        paymentDetails,
        servicesDetails,
        additionalMobiles,
        additionalWhatsapps,
        additionalLandlines,
        additionalEmails,
        additionalServices
    };
    // console.log(selectedCategory, selectedSubCategory);


    const handlePlaceSelect = () => {
        // Check if autocompleteRef.current is initialized
        if (autocompleteRef.current) {
            const place = autocompleteRef.current.getPlace();
            if (!place || !place.address_components) return;

            const addressComponents = place.address_components;
            const getAddressComponent = (type) => {
                const component = addressComponents.find((comp) => comp.types.includes(type));
                return component ? component.long_name : '';
            };
            console.log(place.formatted_address)
            setGoogleAddress(place.formatted_address);
        }
    };

    const handlePlaceSelect1 = () => {
        if (autocompleteRef1.current) {
            const place = autocompleteRef1.current.getPlace();
            if (!place || !place.address_components) return;

            const addressComponents = place.address_components;

            const getAddressComponent = (type) => {
                const component = addressComponents.find((comp) => comp.types.includes(type));
                return component ? component.long_name : '';
            };

            const city = getAddressComponent('locality');
            const pinCode = getAddressComponent('postal_code');
            console.log(city, pinCode)
            // If city and pin code are found, add them to the cities array
            if (city) {
                setCities(prevCities => [...prevCities, { city, pinCode }]);
                setGoogleAddresss(''); // Clear the input after adding
            }
        }
    };

    const handleDeleteCity = (index) => {
        setCities(prevCities => prevCities.filter((_, i) => i !== index));
    };

    console.log(store)

    const storedoneornot = async () => {
        try {
            const baseUrl = getApiBaseUrl();
            const response = await fetch(`${baseUrl}/store/getstorelist/mystore/${login.permanent_ID}`);
            const res = await response.json();
            if (response.ok && res) {
                setStore(true);
            } else {
                setStore(false);
            }
        } catch (error) {
            console.log(error)
        }
    }


    useEffect(() => {
        void fetchDataCategory();
        void storedoneornot();
        void getPlan();
        onOpen();
    }, []);

    useEffect(() => {
        if (!loadedDraft) return; // 🚀 Prevent overwriting before restore

        const savedData = {
            businessDetails,
            contactDetails,
            businessTiming,
            servicesDetails,
            paymentDetails,
            gst,
            aadharNumber,
            panNumber,
            socialMediaLinks,
            selectedLocation,
            selectedCategory,
            selectedSubCategory,
            additionalMobiles,
            additionalWhatsapps,
            additionalLandlines,
            additionalEmails,
            additionalServices,
            google_address,
            businessDate,
        };

        localStorage.setItem("listingFormDraft", JSON.stringify(savedData));

    }, [
        loadedDraft, // Make sure draft is loaded before saving
        businessDetails,
        contactDetails,
        businessTiming,
        servicesDetails,
        paymentDetails,
        gst,
        aadharNumber,
        panNumber,
        socialMediaLinks,
        selectedLocation,
        selectedCategory,
        selectedSubCategory,
        additionalMobiles,
        additionalWhatsapps,
        additionalLandlines,
        additionalEmails,
        additionalServices,
        google_address,
        businessDate
    ]);



    useEffect(() => {
        const saved = JSON.parse(localStorage.getItem("listingFormDraft"));

        if (saved) {
            setBusinessDetails(saved.businessDetails || {});
            setContactDetails(saved.contactDetails || {});
            setBusinessTiming(saved.businessTiming || { timeSlots: [{ day: "", openTime: "", closeTime: "" }] });
            setServicesDetails(saved.servicesDetails || {});
            setPaymentDetails(saved.paymentDetails || {});
            setGst(saved.gst || {});
            setAadharNumber(saved.aadharNumber || "");
            setPanNumber(saved.panNumber || "");
            setSocialMediaLinks({ ...emptySocialMediaLinks(), ...(saved.socialMediaLinks || {}) });
            setSelectedLocation(saved.selectedLocation || { lat: "", lng: "" });
            setSelectedCategory(saved.selectedCategory || "");
            setSelectedSubCategory(saved.selectedSubCategory || "");
            setAdditionalMobiles(saved.additionalMobiles || []);
            setAdditionalWhatsapps(saved.additionalWhatsapps || []);
            setAdditionalLandlines(saved.additionalLandlines || []);
            setAdditionalEmails(saved.additionalEmails || []);
            setAdditionalServices(saved.additionalServices || []);
            setGoogleAddress(saved.google_address || "");
            setBusinessdate(saved.businessDate || "");
        }

        setLoadedDraft(true);  // important ##
    }, []);



    useEffect(() => {
        if (!isOpen) setLocationDetectLoading(false);
    }, [isOpen]);

    const handleDetect = () => {
        if (!navigator.geolocation) {
            toast({
                description: "Geolocation is not supported by your browser.",
                status: "warning",
                duration: 5000,
                position: "top",
                isClosable: true,
            });
            return;
        }

        setLocationDetectLoading(true);

        navigator.geolocation.getCurrentPosition(
            (position) => {
                setSelectedLocation({
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                });

                const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${position.coords.latitude},${position.coords.longitude}&sensor=false&key=AIzaSyD0AcxoBWhqkMIAfK-F-X6ya3Es-52o1YU`;
                fetch(url)
                    .then((res) => res.json())
                    .then((res) => {
                        const formatted = res.results?.[0]?.formatted_address;
                        if (formatted) {
                            setVendorLocation(formatted);
                            setGoogleAddress(formatted);
                            onClose();
                            if (store) {
                                toast({
                                    description: "Store is Registered already",
                                    status: "warning",
                                    duration: 9000,
                                    position: "top-center",
                                    isClosable: true,
                                });
                            }
                            return;
                        }
                        toast({
                            description: "Could not resolve address for this location.",
                            status: "warning",
                            duration: 5000,
                            position: "top",
                            isClosable: true,
                        });
                    })
                    .catch((error) => {
                        console.log(error);
                        toast({
                            description: "Could not load address. Please try again.",
                            status: "error",
                            duration: 5000,
                            position: "top",
                            isClosable: true,
                        });
                    })
                    .finally(() => {
                        setLocationDetectLoading(false);
                    });
            },
            () => {
                setLocationDetectLoading(false);
                toast({
                    description: "Please allow location access to detect your position.",
                    status: "warning",
                    duration: 5000,
                    position: "top",
                    isClosable: true,
                });
            }
        );
    };

    // Function to handle sharing


console.log(businessDetails)


    // console.log(selectedLocation, vendor_location);

    if (!isLoaded) return <p>Loading...</p>;
    const renderStepContent = () => {
        switch (step) {
            case 0:
                return (
                    <div className="form-step">
                        <h2>Enter Your Details</h2>
                        <input type="text" name="businessName" placeholder="Full Name / Team Name / Company Name:" value={businessDetails.businessName} onChange={handleBusinessDetailsChange} />

                        <input type="text" name="buildingName" placeholder="Building Name" value={businessDetails.buildingName} onChange={handleBusinessDetailsChange} />
                        <div className='city'>
                            <input type="text" name="street" placeholder="Street" value={businessDetails.street} onChange={handleBusinessDetailsChange} />
                            <input type="text" name="landmark" placeholder="Landmark" value={businessDetails.landmark} onChange={handleBusinessDetailsChange} />
                        </div>
                        <div className='area'>
                            <input type="text" name="area" placeholder="Area" value={businessDetails.area} onChange={handleBusinessDetailsChange} />
                            <input type="text" name="pincode" placeholder="Pincode" value={businessDetails.pincode} onChange={handleBusinessDetailsChange} />
                        </div>
                        <div className="city"  style={{ position: "relative", width: "100%" }}>

                            {/* STATE SEARCH BOX */}
                            <input
                                type="text"
                                placeholder="State"
                                value={businessDetails.state}
                                onChange={(e) => {
                                    const typed = e.target.value;

                                    setBusinessDetails({
                                        ...businessDetails,
                                        state: typed
                                    });

                                    // filter states as user types
                                    const filtered = INDIA_DATA.filter(state =>
                                        state.name.toLowerCase().includes(typed.toLowerCase())
                                    );

                                    setFilteredStates(filtered);
                                    setShowStateDropdown(true);
                                }}
                                onFocus={() => setShowStateDropdown(true)}
                            />

                            {/* STATE DROPDOWN */}
                            {showStateDropdown && filteredStates.length > 0 && (
                                <div className="newstatedropdown-box">
                                    {filteredStates.map((state) => (
                                        <div
                                            key={state.id}
                                            className="newstatedropdown-item"
                                            onClick={() => {
                                                setBusinessDetails({
                                                    ...businessDetails,
                                                    state: state.name,
                                                    city: ""
                                                });

                                                // ★ Load city array from selected state
                                                setCities(state.cities || []);

                                                setFilteredCities(state.cities || []); // default filter

                                                setShowStateDropdown(false);
                                                setShowCityDropdown(false);
                                            }}

                                        >
                                            {state.name}
                                        </div>
                                    ))}
                                </div>
                            )}


                            {/* CITY SEARCH BOX */}
                            <input
                                type="text"
                                placeholder="City"
                                value={businessDetails.city}
                                onChange={(e) => {
                                    const typed = e.target.value;

                                    setBusinessDetails({
                                        ...businessDetails,
                                        city: typed
                                    });

                                    // ★ Filter cities only from selected state's city list
                                    const filtered = cities.filter((city) =>
                                        city.toLowerCase().includes(typed.toLowerCase())
                                    );

                                    setFilteredCities(filtered);
                                    setShowCityDropdown(true);
                                }}

                                onFocus={() => setShowCityDropdown(true)}
                            />

                            {/* CITY DROPDOWN */}
                            {showCityDropdown && filteredCities.length > 0 && (
                                <div className="newstatedropdown-box">
                                    {filteredCities.map((city, index) => (
                                        <div
                                            key={index}
                                            className="newstatedropdown-item"
                                            onClick={() => {
                                                setBusinessDetails({
                                                    ...businessDetails,
                                                    city: city
                                                });
                                                setShowCityDropdown(false);
                                            }}
                                        >
                                            {city}
                                        </div>
                                    ))}
                                </div>
                            )}

                        </div>

                        <Autocomplete
                            onLoad={(autocomplete) => (autocompleteRef.current = autocomplete)}
                            onPlaceChanged={handlePlaceSelect}
                        >
                            <input type="text"
                                placeholder="Search your business/current location (Google)"
                                value={google_address}
                                onChange={(e) => setGoogleAddress(e.target.value)} />
                        </Autocomplete>

                        <div style={{ height: "220px" }}>
                            <ReactQuill
                                theme="snow"
                                value={businessDetails.description || ""}
                                onChange={(value) =>
                                    setBusinessDetails({ ...businessDetails, description: value })
                                }
                                placeholder="Business/Profile Description"
                                style={{ height: "180px" }}
                            />
                        </div>

                        <div style={{ marginTop: "40px" }}>
                            <label className='busniesssince'>In Business Since:</label><br></br>
                            {/* <input type="date" name="businessDate" placeholder="businessDate" value={businessDate} onChange={(e) => setBusinessdate(e.target.value)} /> */}
                            <Flatpickr
                                value={businessDate}
                                onChange={(date) => setBusinessdate(date[0])}
                                options={{
                                    dateFormat: "d/m/Y",
                                    altInput: true,
                                    altFormat: "d/m/Y",
                                    allowInput: true,
                                    maxDate: "today"
                                }}
                                placeholder="dd/mm/yyyy"
                                className="date-picker-input"
                            />
                        </div>
                        <div className="listing-form-buttons">
                            <button className='listing-save-button' onClick={handleNextStep}>Save and Continue</button>

                        </div>

                    </div>
                );
            case 1:
                return (
                    <div className="form-step">
                        <h2>Add Contact Details</h2>
                        <div className='person'>
                            <select name="title" value={contactDetails.title} onChange={handleContactDetailsChange} className="title">
                                <option value="" disabled selected>Title</option>
                                <option value="Mr">Mr</option>
                                <option value="Mrs">Mrs</option>
                                <option value="Ms">Ms</option>
                            </select>
                            <input type="text" name="personName" value={contactDetails.personName} placeholder="Person Name" onChange={handleContactDetailsChange} className='person-name' />
                        </div>
                        <div className='person-number'>
                            <div className='contact91'>+91</div>
                            <input type="number" name="mobile" value={contactDetails.mobile} placeholder="Mobile Number" onChange={handleContactDetailsChange} />
                        </div>
                        {additionalMobiles.map((mobile, index) => (
                            <div key={index} className="person-number">
                                <div className="contact91">+91</div>
                                <input
                                    type="number"
                                    value={mobile}
                                    onChange={(e) => handleAdditionalMobileChange(index, e)}
                                    placeholder={`Additional Mobile ${index + 1}`}
                                />
                                <button onClick={() => removeMobileField(index)} className="close-button">×</button>
                            </div>
                        ))}
                        <button className='add-more-listing-button listing-add-button' onClick={addNewMobileField}>
                            + Add Another Mobile Number
                        </button>

                        <div className='person-number'>
                            <div className='contact91'>+91</div>
                            <input type="number" name="whatsapp" value={contactDetails.whatsapp} placeholder="WhatsApp Number" onChange={handleContactDetailsChange} />
                        </div>
                        {additionalWhatsapps.map((whatsapp, index) => (
                            <div key={index} className="person-number">
                                <div className="contact91">+91</div>
                                <input
                                    type="text"
                                    value={whatsapp}
                                    onChange={(e) => handleAdditionalWhatsappChange(index, e)}
                                    placeholder={`Additional WhatsApp ${index + 1}`}
                                />
                            </div>
                        ))}
                        <button className='add-more-listing-button listing-add-button' onClick={addNewWhatsAppField}>
                            + Add Another WhatsApp Number
                        </button>
                        <br /> <br />
                        <button id='landline-plus-button' className='listing-add-button' onClick={addNewLandlineField}>
                            + Add Another Landline Number
                        </button>
                        {additionalLandlines.map((landline, index) => (
                            <input
                                key={index}
                                type="text"
                                value={landline}
                                onChange={(e) => handleAdditionalLandlineChange(index, e)}
                                placeholder={`Additional Landline ${index + 1}`}
                            />
                        ))}


                        <input type="email" name="email" value={contactDetails.email} placeholder="Email ID" onChange={handleContactDetailsChange} />
                        {additionalEmails.map((email, index) => (
                            <input
                                key={index}
                                type="email"
                                value={email}
                                onChange={(e) => handleAdditionalEmailChange(index, e)}
                                placeholder={`Additional Email ${index + 1}`}
                            />
                        ))}
                        <button id='email-plus-button' className='listing-add-button' onClick={addNewEmailField}>
                            + Add Another Email Address
                        </button>

                        <br /><br />
                        <Text fontSize="sm" color="gray.600" mb={1}>Enter Aadhar Number <Text as="span" color="gray.500">(optional)</Text></Text>
                        <input
                            type="text"
                            name="aadharNumber"
                            value={aadharNumber}
                            onChange={(e) => {
                                setAadharNumber(e.target.value);
                                if (aadharFieldError) setAadharFieldError("");
                            }}
                            placeholder="Enter a valid Aadhar Number"
                            autoComplete="off"
                            style={aadharFieldError ? { borderColor: "#e53e3e", borderWidth: "2px" } : undefined}
                        />
                        {aadharFieldError ? (
                            <Text fontSize="sm" color="red.500" mt={1}>{aadharFieldError}</Text>
                        ) : null}
                        <Text fontSize="sm" color="gray.600" mt={3} mb={1}>Enter Pan Number <Text as="span" color="gray.500">(optional)</Text></Text>
                        <input
                            type="text"
                            name="panNumber"
                            value={panNumber}
                            onChange={(e) => {
                                setPanNumber(e.target.value);
                                if (panFieldError) setPanFieldError("");
                            }}
                            placeholder="Enter a valid Pan Number"
                            autoComplete="off"
                            style={panFieldError ? { borderColor: "#e53e3e", borderWidth: "2px" } : undefined}
                        />
                        {panFieldError ? (
                            <Text fontSize="sm" color="red.500" mt={1}>{panFieldError}</Text>
                        ) : null}

                        <br />
                        <Text fontSize="md" fontWeight="600" mt={4} mb={2}>Social media &amp; IMDb <Text as="span" fontWeight="400" color="gray.500" fontSize="sm">(optional)</Text></Text>
                        {[
                            { key: "facebook", label: "Facebook profile or page URL" },
                            { key: "instagram", label: "Instagram URL" },
                            { key: "twitter", label: "X (Twitter) URL" },
                            { key: "youtube", label: "YouTube channel URL" },
                            { key: "linkedin", label: "LinkedIn URL" },
                            { key: "imdb", label: "IMDb profile URL" },
                        ].map(({ key, label }) => (
                            <div key={key} style={{ marginBottom: "10px" }}>
                                <Text fontSize="sm" color="gray.600" mb={1}>{label}</Text>
                                <input
                                    type="url"
                                    value={socialMediaLinks[key] || ""}
                                    onChange={(e) => handleSocialLinkChange(key, e.target.value)}
                                    placeholder={`https://…`}
                                    autoComplete="off"
                                />
                            </div>
                        ))}

                        <br /><br />
                        <div className="listing-form-buttons">
                            <button className='listing-save-button' onClick={handleNextStep}>Save and Continue</button>
                            <button className='listing-skip-button' onClick={handlePrevStep}>Previous</button>
                        </div>

                    </div>
                );
            case 2:
                return (
                    <div className="form-step">

                        <h2>Add Business/Availability time</h2>
                        <p className='daysofweek-p'>Let people know your availability</p>
                        {/* <div className="days-of-week">
                            {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map(day => (
                                <label key={day} className={businessTiming.selectedDays[day] ? 'selected-day' : ''}>
                                    <input
                                        type="checkbox"
                                        checked={businessTiming.selectedDays[day] || false}
                                        onChange={() => handleCheckboxChange(day)}
                                    />
                                    {day}
                                </label>
                            ))}
                        </div> */}


                        {/* <div className='days-week-select-all'>
                            <button className='select-all-button' onClick={handleSelectAllDays}>
                                {Object.keys(businessTiming.selectedDays).length === 7 && Object.values(businessTiming.selectedDays).every(Boolean) ? 'Deselect All Days' : 'Select All Days'}
                            </button>
                        </div> */}

                        <div className='time'>
                            {renderTimeSlots()}

                            {/* <button className="add-more-listing-button listing-add-button" onClick={handleAddTimeSlot}>
    + Add Another Time Slot
</button> */}
                            {/* {businessTiming.timeSlots.map((slot, index) => (
                                <div key={index} className='time-slot'>
                                    <div className='time-slot-list'>
                                        <select name="openTime" value={slot.openTime} onChange={(e) => handleTimeSlotChange(index, e)}>
                                            <option value="">Select Open Time</option>
                                            {Array.from({ length: 24 }, (_, i) => (
                                                <option value={`${i < 10 ? '0' : ''}${i}:00`}>{`${i < 10 ? '0' : ''}${i}:00`}</option>
                                            ))}
                                        </select>
                                        <select name="closeTime" value={slot.closeTime} onChange={(e) => handleTimeSlotChange(index, e)}>
                                            <option value="">Select Close Time</option>
                                            {Array.from({ length: 24 }, (_, i) => (
                                                <option value={`${i < 10 ? '0' : ''}${i}:00`}>{`${i < 10 ? '0' : ''}${i}:00`}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            ))} */}
                        </div>
                        <button className='add-more-listing-button listing-add-button' onClick={handleAddTimeSlot}>
                            + Add Another Time Slot
                        </button>
                        <br /><br />

                        <div className="listing-form-buttons">
                            <button className='listing-save-button' onClick={handleNextStep}>Save and Continue</button>
                            <button className='listing-skip-button' onClick={handlePrevStep}>Previous</button>
                        </div>
                    </div>
                );
            case 3:
                return (
                    <div className="form-step">
                        <h2>Add Details</h2>
                        <input type="text" name="service" value={servicesDetails.service} placeholder="Add Service/Skills" onChange={handleServicesDetailsChange} />
                        {additionalServices.map((service, index) => (
                            <input
                                key={index}
                                type="text"
                                value={service}
                                onChange={(e) => handleAdditionalServicesChange(index, e)}
                                placeholder={`Additional Service/Skills ${index + 1}`}
                            />
                        ))}
                        <button id='email-plus-button' className='listing-add-button' onClick={addNewServicesField}>
                            + Add Another Service/Skills
                        </button>

                        <br /><br />
                        {/* Category Dropdown */}
                        <Select onChange={handleCategoryChange} value={selectedCategory} placeholder="Select Category">

                            {categories.map((category) => (
                                <option key={category.id} value={category.category_name}>
                                    {category.category_name}
                                </option>
                            ))}
                        </Select>

                        {/* Subcategory Dropdown (if any) */}
                        {subCategories.length > 0 && (
                            <Select onChange={handleSubCategoryChange} value={selectedSubCategory} placeholder="Select Subcategory">

                                {subCategories.map((subCategory) => (
                                    <option key={subCategory.id} value={subCategory.subcategory_name}>
                                        {subCategory.subcategory_name}
                                    </option>
                                ))}
                            </Select>
                        )}

                        <br />
                        <Text size="sm" mt={0}>
                            Do you have Tax ID?
                        </Text>
                        <Select
                            placeholder="Select Option"
                            onChange={(e) => {
                                const value = e.target.value;
                                setGst({
                                    ...gst,
                                    gstAvailable: value,
                                    gstNumber: value === "Yes" ? gst.gstNumber || "" : "", // Clear GST number if "No" is selected
                                });
                            }}
                            value={gst.gstAvailable}
                        >
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                        </Select>

                        {gst.gstAvailable === "Yes" && (
                            <input
                                type="text"
                                name="gstNumber"
                                value={gst.gstNumber || ""}
                                placeholder="Enter Tax ID"
                                onChange={(e) =>
                                    setGst({
                                        ...gst,
                                        gstNumber: e.target.value,
                                    })
                                }
                            />
                        )}
                        <div className="listing-form-buttons">
                            <button className='listing-save-button' onClick={handleNextStep}>Save and Continue</button>
                            <button className='listing-skip-button' onClick={handlePrevStep}>Previous</button>
                        </div>

                    </div>
                );
            case 4:
                return (
                    <div className="form-step">
                        <h2>Add Photos</h2>
                        <ImageUpload files={formImages} onFilesChange={setFormImages} />
                        <div className="listing-form-buttons">
                            <button className='listing-save-button' onClick={handleNextStep}>Save and Continue</button>
                            <button className='listing-skip-button' onClick={handlePrevStep}>Previous</button>
                        </div>
                    </div>
                );



            case 5:
                return (
                    <div className="form-step">
                        <h2>Payment Details</h2>
                        <input type="text" name="beneficiaryName" value={paymentDetails.beneficiaryName} placeholder="Beneficiary Name (optional)" onChange={handlePaymentDetailsChange} />
                        <input
                            type={focusedField === 'accountNumber' ? 'text' : 'password'} // Show text when focused, otherwise hide
                            name="accountNumber"
                            value={paymentDetails.accountNumber}
                            placeholder="Bank Account Number (optional)"
                            onFocus={() => setFocusedField('accountNumber')}
                            onBlur={() => setFocusedField('')}
                            onChange={handlePaymentDetailsChange}
                        />
                        <input type="text" name="confirmaccountNumber" value={paymentDetails.confirmaccountNumber} placeholder="Confirm Bank Account Number (optional)" onChange={handlePaymentDetailsChange} />
                        <input type="text" name="bankName" value={paymentDetails.bankName} placeholder="Bank Name (optional)" onChange={handlePaymentDetailsChange} />
                        <input type="text" name="ifscCode" value={paymentDetails.ifscCode} placeholder="IFSC Code (optional)" onChange={handlePaymentDetailsChange} />

                        <div className="listing-form-buttons">
                            {
                                load ?
                                    <button
                                        className='listing-save-button'
                                        onClick={() => {
                                            if (!validateStep(5)) return;
                                            if (!plan || plan.length === 0) {
                                                toast({
                                                    title: "Plans unavailable",
                                                    description:
                                                        "We could not load registration plans. Check your connection, refresh the page, then try Submit again.",
                                                    status: "warning",
                                                    duration: 10000,
                                                    isClosable: true,
                                                    position: "top",
                                                });
                                                return;
                                            }
                                            openModal2();
                                        }}
                                    >
                                        Submit
                                    </button> :
                                    <button className='listing-save-button' ><Spinner /></button>
                            }

                            <button className='listing-skip-button' onClick={handlePrevStep}>Previous</button>
                        </div>
                    </div>
                );
            default:
                return null;
        }
    };

    return (
        <>
            <Header />
            <Modal
                isOpen={listingResultModal.isOpen}
                onClose={
                    listingResultModal.variant === "error"
                        ? closeListingResultModal
                        : () => {}
                }
                closeOnOverlayClick={listingResultModal.variant === "error"}
                closeOnEsc={listingResultModal.variant === "error"}
                isCentered
                size="md"
            >
                <ModalOverlay bg="blackAlpha.600" backdropFilter="blur(4px)" />
                <ModalContent borderRadius="2xl" overflow="hidden" boxShadow="2xl" mx={4}>
                    {listingResultModal.variant === "error" && <ModalCloseButton />}
                    <ModalBody pt={10} pb={6} px={{ base: 6, md: 10 }}>
                        <VStack spacing={5}>
                            <Flex
                                w={16}
                                h={16}
                                borderRadius="full"
                                bg={listingResultModal.variant === "success" ? "green.50" : "red.50"}
                                align="center"
                                justify="center"
                            >
                                {listingResultModal.variant === "success" ? (
                                    <CheckCircleIcon w={9} h={9} color="green.500" />
                                ) : (
                                    <WarningTwoIcon w={9} h={9} color="red.500" />
                                )}
                            </Flex>
                            <Heading size="md" textAlign="center" color="gray.800">
                                {listingResultModal.variant === "success"
                                    ? "You're all set"
                                    : "Something went wrong"}
                            </Heading>
                            <Text textAlign="center" color="gray.600" lineHeight="tall" fontSize="md">
                                {listingResultModal.message}
                            </Text>
                        </VStack>
                    </ModalBody>
                    <ModalFooter justifyContent="center" pt={0} pb={8} gap={3}>
                        {listingResultModal.variant === "success" ? (
                            <Button
                                colorScheme="brand"
                                size="lg"
                                px={12}
                                onClick={confirmListingSuccess}
                                borderRadius="full"
                            >
                                Confirm
                            </Button>
                        ) : (
                            <Button
                                colorScheme="brand"
                                variant="outline"
                                size="lg"
                                px={12}
                                onClick={closeListingResultModal}
                                borderRadius="full"
                            >
                                OK
                            </Button>
                        )}
                    </ModalFooter>
                </ModalContent>
            </Modal>
            <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false}>
                <ModalOverlay />
                <ModalContent>
                    {/* <ModalHeader>Modal Title</ModalHeader> */}
                    {/* <ModalCloseButton /> */}
                    <ModalBody>
                        {locationDetectLoading ? (
                            <Flex direction="column" align="center" justify="center" py={10} gap={4}>
                                <Spinner size="xl" thickness="4px" color="brand.500" />
                                <Text textAlign="center" color="gray.600" fontSize="sm">
                                    Getting your location and address…
                                </Text>
                            </Flex>
                        ) : (
                            <>
                                <Text textAlign={"center"} mt={"30px"}>Are you at your business location?</Text>
                                <Box mt={"10px"}>
                                    <Flex textAlign={"center"} justifyContent={"center"}>
                                        <Button
                                            mr={3}
                                            bg={"#0be10b"}
                                            color={"white"}
                                            _hover={{ background: "#04b904", color: "white", fontWeight: "600" }}
                                            onClick={handleDetect}
                                        >
                                            Yes
                                        </Button>
                                        <Button
                                            bg={"brand.500"}
                                            color={"white"}
                                            _hover={{ background: "brand.600", color: "white", fontWeight: "600" }}
                                            onClick={() => {
                                                setLocationDetectLoading(false);
                                                onClose();
                                            }}
                                        >
                                            No
                                        </Button>
                                    </Flex>
                                </Box>
                            </>
                        )}
                    </ModalBody>
                    <ModalFooter>

                    </ModalFooter>

                </ModalContent>
            </Modal>
            <Modal
                isOpen={isModal2Open}
                closeOnOverlayClick={false}
                size={{ base: "full", sm: "full", md: "full", lg: "5xl", xl: "5xl" }}
                onClose={closeModal2}
                scrollBehavior="inside" // Enable scrolling inside the modal
            >
                <ModalOverlay />
                <ModalContent>
                    <Box position="absolute" top={2} right={4}>
                        <CloseIcon onClick={closeModal2} cursor="pointer" />
                    </Box>
                    <ModalBody overflowY="auto" maxH="calc(100vh - 100px)"> {/* Explicit scrolling */}
                        <Box bg="brand.50" p={"15px"}>
                            <VStack spacing={4} mb={10}>
                                <Heading color="brand.600">Plans</Heading>
                                <Text textAlign="center" color="gray.600">
                                    To Register your store you need to pay the amount below and after that will get listed in bigbullpaisewala store
                                </Text>
                            </VStack>

                            <Flex wrap="wrap" justify="center" gap={6}>
                                {plan.map((plan, index) => (
                                    <Box
                                        key={index}
                                        bg="white"
                                        shadow="xl"
                                        borderRadius="lg"
                                        p={6}
                                        w="280px"
                                        textAlign="center"
                                        border={planobject.plan_name === plan.plan_name ? "2px solid" : "1px solid"}
                                        borderColor={planobject.plan_name === plan.plan_name ? "brand.500" : "gray.200"}
                                    >
                                        <Badge
                                            colorScheme="brand"
                                            variant="solid"
                                            borderRadius="full"
                                            px={3}
                                            py={1}
                                            mb={4}
                                            fontSize="sm"
                                            alignSelf="center"
                                        >
                                            {plan.plan_name}
                                        </Badge>
                                        <Heading color="brand.600" fontSize="4xl">
                                            ₹{plan.sale_price}
                                            <Text as="span" textDecoration={"line-through"} fontSize="lg" ml={"5px"} color="gray.600">
                                                ₹{plan.regular_price}
                                            </Text>
                                        </Heading>
                                        <Text as="span" fontSize="md" ml={"5px"} color="gray.600">
                                            {plan.validity}days
                                        </Text>
                                        <Divider my={6} borderColor="gray.300" />
                                        <VStack spacing={3} mb={6}>
                                            <Text as="span" fontSize="lg" color="gray.600">
                                                {plan.description}
                                            </Text>
                                        </VStack>
                                        <Button
                                            bg={planobject.plan_name === plan.plan_name ? "brand.600" : "brand.500"}
                                            color={"white"}
                                            size="lg" w="full"
                                            onClick={() => {
                                                setPlanObject(plan);     // Select plan
                                                closeModal2();           // Close modal
                                                setTimeout(() => {
                                                    handlePayment(plan);     // 🔥 Trigger payment automatically
                                                }, 100);                 // Small delay to ensure modal closes
                                            }}
                                            _hover={{ bg: planobject.plan_name === plan.plan_name ? "brand.600" : "brand.500" }}
                                        >
                                            {planobject.plan_name === plan.plan_name ? "SELECTED" : "SELECT"}
                                        </Button>
                                    </Box>
                                ))}
                            </Flex>
                        </Box>
                    </ModalBody>
                </ModalContent>
            </Modal>


            <Modal isOpen={isModal1Open} onClose={closeModal1} closeOnOverlayClick={false}>
                <ModalOverlay />
                <ModalContent>
                    {/* <ModalHeader>Modal Title</ModalHeader> */}
                    <ModalCloseButton />
                    <ModalBody>
                        <Text textAlign={"center"} mt={"30px"}>If you are not close to your store, please don't proceed elsewhere to avoid issues with service providers / talent.</Text>
                        <Button display={"block"} margin={"auto"} mt={3} bg={"brand.500"} color={"white"} _hover={{ background: "brand.600", color: "white", fontWeight: "600" }}>Home</Button>
                    </ModalBody>
                    <ModalFooter>

                    </ModalFooter>

                </ModalContent>
            </Modal>
            <div className="listing-form">
                <div className="listing-form-container">
                    <div className="listing-form-image">
                        <img src={vendorFormImage} alt="Listing" />
                    </div>
                    <div className="listing-form-content">
                        {renderProgressBar()}
                        {renderStepContent()}
                    </div>
                </div>
            </div>
        </>
    );
};

export default ListingForm;
